{
  "modal": {
    "buttonLabel": "Filifili se taimi fou",
    "text": "Ua uma ona fa‘aagaga lea taimi e se isi.",
    "title": "Ua tuai i le mea iti!"
  },
  "nextLabel": "$t(common:next): <b>Fa‘aagaga le taimi o le tofiga</b>",
  "nextWeek": "I le vaiaso fou",
  "noTimeText": "E leai ni taimi avanoa mo le aso na e filifilia.",
  "prevWeek": "Vaiaso ua te‘a",
  "title": "Filifili le taimi o lau tofiga"
}
